import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCRaymond extends NPC {
    constructor() {
        super(definitions.NPC_ID.RAYMOND);

        this.collisionRadius = 25;
        this.collisionOffsetX = -14;
        this.collisionOffsetY = -36;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_raymond_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(-15, -12));
        this.animateIdle(0.6);
    }

    onViewAdded() {
        super.onViewAdded();

        this._status.y += 16;
    }
}